<template>
  <div class="auth-description">
    <h2 class="auth-title">
      {{ $t('Welcome to Fixtender') }}
    </h2>
    <div>
      <span class="text text-grey">
        <span class="text-bold">{{ inviter }}</span>
        {{ $t('wants you to join') }}
        <span class="text-bold">{{ company }}</span
        >.
        {{ $t('Please fill in all the fields below to sign up.') }}
      </span>
    </div>
    <Form
      class="login-form auth"
      :error="error"
      :error-text="error"
      :success="isDone"
      :success-text="$t('You have successfully registered. Wait to be redirected.')"
      @submit="submit"
    >
      <FormInput
        id="name-input"
        v-model="name"
        required
        :label-text="$t('Name')"
        :placeholder="$t('Enter your name')"
      />

      <FormInput
        id="email-input"
        v-model="email"
        type="email"
        disabled
        placeholder="e.g. john@gmail.com"
        :label-text="$t('Email')"
      />

      <div class="register-passwords formcell">
        <FormInput
          id="pass-input"
          v-model="password"
          type="password"
          :placeholder="$t('Enter your password')"
          :input-info="$t('At least 6 characters with number')"
          :label-text="$t('Password')"
          :success="samePasswords"
        />

        <FormInput
          id="pass2-input"
          v-model="password2"
          type="password"
          :error="$v.password2.$error"
          :error-message="$t('Passwords don’t match')"
          :placeholder="$t('Repeat your password')"
          :label-text="$t('Repeat')"
          :success="samePasswords"
        />
      </div>
      <button :disabled="isLoading || isDone" type="submit" class="btn-primary w-button w-full">
        <Spinner v-if="isLoading" size="20" />
        <span v-else> {{ $t('Sign up') }}</span>
      </button>
    </Form>
  </div>
</template>

<script>
  import { validationMixin } from 'vuelidate';
  import { minLength, required, sameAs } from 'vuelidate/lib/validators';
  import Form from '@/components/common/Form';
  import parseError from '@/utils/formatting/parse-error';
  import FormInput from '@/components/ui/FormInput';
  import email from 'vuelidate/lib/validators/email';
  import request from '@/utils/api/request';
  import factory from '@/utils/api/factory';
  import { mapActions } from 'vuex';
  import { changeLocale } from '@/i18n';

  export default {
    name: 'Invite',
    components: {
      FormInput,
      Form,
    },
    mixins: [validationMixin],
    data() {
      return {
        name: '',
        email: '',
        password: '',
        password2: '',
        isLoading: false,
        isDone: false,
        error: null,

        company: '',
        inviter: '',
      };
    },
    validations: {
      name: { required, minLength: minLength(2) },
      email: { required, email },
      password: { required, minLength: minLength(6) },
      password2: { required, sameAsPassword: sameAs('password') },
    },
    computed: {
      samePasswords() {
        return this.$v.password.required && this.$v.password2.sameAsPassword;
      },
    },
    async created() {
      try {
        let { data } = await request.get(`/register/invitation/${this.$route.params.hash}/`);

        changeLocale(data.language);
        this.email = data.email;
        this.inviter = data['inviter_user_name'];
        this.company = data['inviter_team_name'];
      } catch (e) {
        await this.$router.push({ name: 'login' });
      }
    },
    methods: {
      ...mapActions('auth', ['setToken', 'login']),
      async submit() {
        this.$v.$touch();
        if (this.$v.$invalid) return;

        this.isLoading = true;
        this.error = null;

        try {
          let { data } = await request.post('/confirm_invitation/', {
            name: this.name,
            password: this.password,
            hash_string: this.$route.params.hash,
          });

          this.setToken(data.register_finish_token);

          await factory('register').postInPath('finish');

          await this.login({
            email: this.email,
            password: this.password,
          });
          location.reload();

          this.isDone = true;
        } catch (e) {
          this.error = parseError(e);
        }

        this.isLoading = false;
      },
    },
  };
</script>
